/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path ui
 * @description Navigation main menu
 * @section 4.5
 *
 */
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import { useErrorContext } from "@qpr/client-library";
import React from "react";
import useNavitems from "./../apihooks/useNavitems";
import HorizontalMenu from "./HorizontalMenu";
interface HorizontalMenuViewProps {
  tenant: string;
}
const useStyles = makeStyles((theme) => ({
  iconDiv: {
    height: "48px",
    width: "48px",
  },
}));
const HorizontalMenuView = ({ tenant }: HorizontalMenuViewProps) => {
  const { setError } = useErrorContext();
  const classes = useStyles();
  const { isLoading, error, data } = useNavitems();
  return isLoading === true || !data ? (
    <div className={classes.iconDiv}>
      <CircularProgress color="inherit" />
    </div>
  ) : (
    <HorizontalMenu menuItems={data} tenant={tenant} />
  );
};
export default HorizontalMenuView;
